var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTool6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 48,
    viewBox: "0 0 35 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.245 47.8787L3.39251 44.0331L0.305481 9.4093H34.2259L31.1357 44.0278L17.245 47.8787Z",
    fill: "#264DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4902 41.8235L31.1308 12.2403H17.2657V44.9352L28.4902 41.8235Z",
    fill: "#2965F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38236 25.0818L7.76291 29.3283H17.2657V25.0818H7.38236ZM6.61755 16.4869L7.00355 20.7333H17.2657V16.4869H6.61755ZM17.2657 36.1104L17.2471 36.1153L12.5178 34.8383L12.2155 31.4516H7.95265L8.54753 38.1192L17.2462 40.5338L17.2657 40.5285V36.1104Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28851 0H13.4316V2.15083H10.4393V4.30165H13.4318V6.45234H8.28851V0ZM14.4603 0H19.6035V1.87027H16.6111V2.2443H19.6035V6.54595H14.4604V4.58194H17.4528V4.20791H14.4602L14.4603 0ZM20.6322 0H25.7754V1.87027H22.783V2.2443H25.7754V6.54595H20.6322V4.58194H23.6246V4.20791H20.6324V0H20.6322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.122 25.0818L27.8885 16.4869H17.2511V20.7333H23.2348L22.8484 25.0818H17.2511V29.3283H22.4802L21.9872 34.8356L17.251 36.114V40.5318L25.9565 38.1192L26.0203 37.4017L27.0184 26.2221L27.122 25.0818Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.0388,
    height: 48,
    fill: "white",
    transform: "translate(0.246338)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool6);
export default __webpack_public_path__ + "static/media/tool6.ef9c10e3da7fcc19133dff7eb6beeb76.svg";
export { ForwardRef as ReactComponent };